module.exports = __webpack_public_path__ + "static/media/m-Mirror image.830040a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m-Mirror image.png
// module id = 172
// module chunks = 0